export const FEATURE_TOGGLES = {
  SHOW_UPSALE_PANEL: 'CM-show-upsale-panel',
  SHOW_LOGS: 'CM-show-logs',
  SHOW_ONBOARDING_PANEL: 'CM-show-onboarding-panel',
  ENABLE_MODEL_VIEW: 'CM-enable-model-view',
  SHOW_3D_PREVIEW_IMAGE: 'CM-show-3D-preview-image',
  ENABLE_ROTATION_ANIMATION: 'CM-enable-rotation-animation',
  ENABLE_SCROLL_TO_SELECTED: 'CM-enable-scroll-to-selected',
  SHOW_ONBOARDING_TIPS: 'CM-show-onboarding-tips',
  ENABLE_AUTOSAVE: 'CM-enable-autosave',
  ENABLE_AVO_TRACKING: 'CM-enable-AVO-tracking',
  MODEL_IMAGE_VERSION: 'CM-model-image-version',
} as const;
